import urls from "../urls";
import { callGetApi } from "../callApi";
import objectToQueryString from "@/utils";

const conversationalService = {
  getSessionMessages: (body: {
    session_id: string;
    page?: number;
    limit?: number;
  }) => {
    // body.session_id = "691a289955802c0599db1c55"
    return callGetApi(`v4/trends/messages` + objectToQueryString(body));
  },
  getHistory: () => {
    return callGetApi("v4/trends/sessions");
  },
  sendChat: (q: string, session_id: string) => {
    return callGetApi(
      urls.SEND_MESSAGE +
        objectToQueryString({
          query: q,
          session_id,
        })
    );
  },
};

export default conversationalService;
